// eslint-disable-next-line no-unused-vars
import React, { useState, useEffect } from "react"

export function useMounted() {
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  return isMounted
}
